import { gql } from '@apollo/client';

const ASSESSMENT_DOMAINS_AND_SECTIONS = gql`
  fragment AssessmentDomainsAndSections on Assessment {
    assessmentDomains {
      domain {
        title
        description
        id
      }
      assessmentSections {
        id
        title
        description
        instructions
        thumbnail
        assessmentSectionQuestions {
          assessmentQuestion {
            id
            text
            instructions
            description
            answerTypeId
            answerType {
              id
              format
              options {
                id
                text
                pointValue
              }
            }
            pointsPossible
          }
        }
      }
    }
  }
`;

const ASSESSMENT_IMPLEMENTATIONS = gql`
  fragment AssessmentImplementations on Assessment {
    id
    type
    ... on BenchmarkAssessment {
      details {
        assessmentId
        period
        productCurriculumId
      }
    }
    ... on UnitAssessment {
      unitId
      unit {
        id
        productCurriculumId
        unitNumber
        title
        description
      }
    }
  }
`;

export { ASSESSMENT_IMPLEMENTATIONS, ASSESSMENT_DOMAINS_AND_SECTIONS };
